module.exports = __webpack_public_path__ + "static/media/heroimage_igib-018.21f543dd.jpg";